import React, { FC } from 'react';
import { PastProjectStatus } from 'api/project';
import { popoverContent } from 'components/organisms/projects/project-list/columns/last-five-updates';
import { useTranslate } from 'hooks/use-translation';

export const LastFiveUpdates: FC<{
  data: PastProjectStatus[];
  projectId: number;
}> = ({ data, projectId }) => {
  const translate = useTranslate();

  return <div>{popoverContent({ projectId, data, translate })}</div>;
};
